import ColorModel from '@models/api/products/color-model'

class VariationsModel {
  constructor(values = {}) {
    this.color = new ColorModel(values?.color || {})
  }
}

export default VariationsModel
